import Vue from "vue";
import Vuex from "vuex";
import * as auth from "./auth.module";
import * as storage from "./storage.module";
import Constant from "./constant";
import { RouterBeforeTask } from "@/router/router-before-task";

Vue.use(Vuex);

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  app: {
    constant: Constant,
    modal: {
      profile: {
        visible: false,
      },
      changePassword: {
        visible: false,
      }
    },
  },
  routerBeforeTask: new RouterBeforeTask(),
};

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
};

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    auth,
    storage,
  },
  actions: {},
});
